export default __webpack_public_path__ + "static/media/icon_5.52c0079d.png";